/**
* DevExpress Analytics (core\tools\toolbox.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var _getNameHelpers_1 = require("../internal/_getNameHelpers");
var _svgTemplateEngine_1 = require("../../property-grid/widgets/internal/_svgTemplateEngine");
var ToolboxItem = (function () {
    function ToolboxItem(info) {
        this.disabled = ko.observable(false);
        this.info = info;
    }
    Object.defineProperty(ToolboxItem.prototype, "type", {
        get: function () {
            return _getNameHelpers_1.getTypeNameFromFullName(this.info['@ControlType']);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToolboxItem.prototype, "imageClassName", {
        get: function () {
            return [_getNameHelpers_1.getImageClassName(this.type), this.disabled() ? 'dxrd-disabled-button' : ''].join(' ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToolboxItem.prototype, "imageTemplateName", {
        get: function () {
            var _templateName = _getNameHelpers_1.getImageClassName(this.type, true);
            return _svgTemplateEngine_1.SvgTemplatesEngine.getExistingTemplate(_templateName);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToolboxItem.prototype, "index", {
        get: function () {
            return this.info.index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToolboxItem.prototype, "displayName", {
        get: function () {
            return this.info.displayName || this.type;
        },
        enumerable: true,
        configurable: true
    });
    return ToolboxItem;
}());
exports.ToolboxItem = ToolboxItem;
